import Immutable from 'seamless-immutable';
import _ from 'lodash';

const UPDATE_LIST = 'UPDATE_CHILD_LIST';
const ADD_ITEM_TO_UP = 'ADD_ITEM_CHILD_TO_UP';
const ADD_ITEM_TO_DOWN = 'ADD_ITEM_CHILD_TO_DOWN';
const INIT_STATE = 'INIT_STATE';

const createReducerDotPathName = (combineName, reducerName) =>
  `${combineName}.${reducerName}`;

const createActionName = (combineName, reducerName, name) =>
  `app/${createReducerDotPathName(combineName, reducerName)}/${name}`;
export const getState = (state, combineName, reducerName) =>
  _.get(state, createReducerDotPathName(combineName, reducerName));

const createListReducer = (parentName, reducerName) => {
  function stateDefault() {
    return {
      childItemsById: {},
      parentsMapIds: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(parentName, reducerName, UPDATE_LIST):
        if (state.mergeItemsMode) {
          return state.merge({
            items: [...state.items, ...action.payload]
          });
        }
        return state.merge({
          childItemsById: action.payload.childItemsById,
          parentsMapIds: action.payload.parentsMapIds
        });
      case createActionName(parentName, reducerName, ADD_ITEM_TO_UP): {
        // TODO Привести в более лаконичный вид
        let newParentItems = [];
        const parentItems = state.parentsMapIds[action.payload.parentId];
        if (!parentItems) {
          newParentItems = [action.payload.itemId];
        } else {
          newParentItems = [...parentItems];
          newParentItems.unshift(action.payload.itemId);
        }
        return state.merge({
          childItemsById: {
            ...state.childItemsById,
            ...{ [action.payload.itemId]: action.payload.item }
          },
          parentsMapIds: {
            ...state.parentsMapIds,
            ...{ [action.payload.parentId]: newParentItems }
          }
        });
      }
      case createActionName(parentName, reducerName, ADD_ITEM_TO_DOWN): {
        // TODO Привести в более лаконичный вид
        let newParentItems = [];
        const parentItems = state.parentsMapIds[action.payload.parentId];
        if (!parentItems) {
          newParentItems = [action.payload.itemId];
        } else {
          newParentItems = [...parentItems];
          newParentItems.push(action.payload.itemId);
        }
        return state.merge({
          childItemsById: {
            ...state.childItemsById,
            ...{ [action.payload.itemId]: action.payload.item }
          },
          parentsMapIds: {
            ...state.parentsMapIds,
            ...{ [action.payload.parentId]: newParentItems }
          }
        });
      }
      case createActionName(parentName, reducerName, INIT_STATE):
        return Immutable({
          ...stateDefault(),
          ...{ mergeItemsMode: action.payload === true }
        });
      default:
        return state;
    }
  };
};

export function createReduceObject(parentName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createListReducer(parentName, reducerName);
  return reduceObject;
}

// ACTIONS CREATOR
export const updateList = (parentName, reducerName, payload) => ({
  type: createActionName(parentName, reducerName, UPDATE_LIST),
  payload
});
export const addItemToUp = (parentName, reducerName, payload) => ({
  type: createActionName(parentName, reducerName, ADD_ITEM_TO_UP),
  payload
});
export const addItemToDown = (parentName, reducerName, payload) => ({
  type: createActionName(parentName, reducerName, ADD_ITEM_TO_DOWN),
  payload
});
export const initState = (parentName, reducerName, payload) => ({
  type: createActionName(parentName, reducerName, INIT_STATE),
  payload
});

// SELECTORS
export const selectChildIdsByParentId = (
  state,
  parentName,
  reducerName,
  parentId
) => {
  const ids = getState(state, parentName, reducerName).parentsMapIds[parentId];
  if (ids) {
    return ids;
  }
  return [];
};

export const selectChildItemById = (
  state,
  parentName,
  reducerName,
  commentId
) => {
  const ids = getState(state, parentName, reducerName).childItemsById[
    commentId
  ];
  if (ids) {
    return ids;
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/mt-react-common/common/reducers/__childMultipleList/reducer.js